export default "__VITE_ASSET__DNyawOy0__"